export default __webpack_public_path__ + "static/media/x-icon.d70d0790.svg";